export const ModifaceColors = {
    modifaceDark: '#393540'
};

export default ModifaceColors;
